var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumber9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.287 17.158c0 3.91-.843 6.74-2.53 8.49-1.685 1.75-4.383 2.625-8.093 2.625-1.221 0-2.151-.045-2.789-.136v-4.28c.784.146 1.568.22 2.352.22 1.932 0 3.422-.397 4.47-1.19 1.048-.802 1.618-2.065 1.71-3.787h-.165c-.355.656-.706 1.13-1.053 1.421-.346.292-.77.515-1.271.67-.501.155-1.126.233-1.873.233-1.732 0-3.085-.579-4.06-1.736-.976-1.158-1.464-2.753-1.464-4.786 0-2.214.63-3.95 1.887-5.209 1.267-1.257 2.999-1.886 5.196-1.886 2.442 0 4.334.81 5.673 2.433 1.34 1.623 2.01 3.929 2.01 6.918zm-7.533-5.031c-.592 0-1.076.214-1.45.643-.364.428-.546 1.116-.546 2.064 0 .747.16 1.344.478 1.791.32.438.807.656 1.463.656.593 0 1.108-.214 1.545-.642.438-.429.656-.944.656-1.545 0-.811-.205-1.509-.615-2.092-.4-.583-.911-.875-1.531-.875z",
    fill: "#fff",
    fillOpacity: 0.2
  })));
}

export default SvgNumber9;